"use client";
import { IGalleries } from "@/api/AppApi/services/home/interfaces/IGallery";
import { Row } from "@/utils/bootstrap";
import GallerySlider from "./GallerySlider";
import GalleryMedia from "./GalleryMedia";
import Separator from "../../lib/Separator";
import useIsClient from "@/hooks/useIsClient";
import GallerySkeleton from "./GallerySkeleton";
import MediaPreviewModal from "../../lib/media-preview-provider/MediaPreviewModal";
import { useRef } from "react";
import PreviewProvider from "../../pages-components/product-details-page/details-belpers/PreviewProvider";

interface Props extends IGalleries {}

const Galleries: React.FC<Props> = (props) => {
  const isClient = useIsClient();
  const videoPreviewRef = useRef<{
    showMedia(src: string, type: "video" | "image"): void;
  } | null>(null);
  const media = props.data;
  const imagesUrl = media
    .filter((m) => m.type === "image")
    .map((item) => item.image_url);
  const separatorName = props.configurations.title;
  const mediaRatio = props.configurations.customize.media_ratio;
  const classNameConfig: Record<typeof mediaRatio, string> = {
    "1:1": "galliery-image-ratio-1-1",
    "4:3": " galliery-image-ratio-4-3",
  };

  const className = classNameConfig[mediaRatio ?? "4:3"];

  return (
    <>
      <Separator startLabel={separatorName} />
      {isClient ? (
        <Row style={{ gap: 12 }} className="m-0 d-flex justify-content-center">
          <PreviewProvider images={imagesUrl}>
            {(openGallery) => (
              <GallerySlider>
                {media.map((m, key) => (
                  <div
                    key={key}
                    onClick={() => {
                      if (m.type === "image") {
                        const imageIndex = imagesUrl.findIndex(
                          (mUrl) => mUrl === m.image_url,
                        );
                        return openGallery(imageIndex);
                      }
                      videoPreviewRef.current?.showMedia(m.image_url, m.type);
                    }}
                  >
                    <GalleryMedia
                      key={key}
                      src={m.image_url}
                      type={m.type}
                      className={className}
                    />
                  </div>
                ))}
              </GallerySlider>
            )}
          </PreviewProvider>
          <MediaPreviewModal ref={videoPreviewRef} />
        </Row>
      ) : (
        <GallerySkeleton media={media as []} className={className} />
      )}
    </>
  );
};

export default Galleries;
